import { ProcessChunkingStrategyWithParams } from 'react-scale/components/scalers/tasks/ThreadedInteraction/definitions/ProcessSupervision/chunking';
export const processUnchunkingStrategies = [
  'UnchunkByDelimiter',
  'UnchunkByDelimiterPair',
] as const;
export type ProcessUnchunkingStrategy = (typeof processUnchunkingStrategies)[number];

export const ProcessUnchunkingStrategyMap: {
  [key in ProcessUnchunkingStrategy]: (chunks: string[], params?: any) => { output: string };
} = {
  UnchunkByDelimiter: (chunks: string[], params) => ({
    output: chunks.join(params.delimiter),
  }),
  UnchunkByDelimiterPair: (chunks: string[], params) => ({
    output: chunks.map(chunk => `${params.startDelimiter}${chunk}${params.endDelimiter}`).join(''),
  }),
};

export const unchunk = (
  chunks: string[],
  { strategy, params }: ProcessChunkingStrategyWithParams,
) => {
  switch (strategy) {
    case 'ChunkBySentence':
    case 'ChunkByNewline':
    case 'ChunkByStepNumber':
    case 'ChunkByRegex':
    case 'ChunkWithGPT':
      return ProcessUnchunkingStrategyMap.UnchunkByDelimiter(chunks, { delimiter: '\n\n' });
    case 'ChunkByDelimiterPair':
      return ProcessUnchunkingStrategyMap.UnchunkByDelimiterPair(chunks, {
        startDelimiter: params!.startDelimiter,
        endDelimiter: params!.endDelimiter + '\n',
      });
  }
};
